<!-- @format -->

<ad-index-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <h1 class="heading-01 heading_recruitment">公募案件を探す</h1>
      </li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <section class="contents_area">
      <div class="tab-menu margin-spacing-4_bottom">
        <ul class="tab-menu-list">
          <li class="tab-menu-list-item is-active">
            <a href="/ad">公募案件一覧</a>
          </li>
          <li class="tab-menu-list-item">
            <a href="/ad/entried">エントリー中</a>
          </li>
          <li class="tab-menu-list-item">
            <a href="/ad/interest">あなたの「気になる」</a>
          </li>
          <li class="tab-menu-list-item">
            <a href="/ad/interested">
              クライアント様からの「気になる」
              <span
                if="{ di.Sidebar.state.interested }"
                class="badge badge-unread"
              ></span>
            </a>
          </li>
        </ul>
      </div>
      <!--/.tab-menu-->

      <div class="tab_contents active">
        <p class="text margin-spacing-4_bottom">
          現在、ライター様を募集中の公募案件の一覧です。
          <!--<br>下記の「<strong>検索条件設定</strong>」ボタンから、条件を細かく設定して検索することができます。-->
        </p>

        <!--
        <div class="wrap_search-conditions margin-spacing-4_bottom">
          <div class="search-conditions_area">
            <p class="search-conditions-heading">現在の検索条件：</p>
            <ul class="search-conditions_list">
              <template each="{key in Object.keys(state.checkboxes)}">
                <li class="search-conditions_list-item" data-key="{key}">
                  <span
                    class="label label-search-conditions js-label-close"
                    onclick="{e=>delSearchCond(e,key)}"
                  >
                    {state.checkboxes[key]}
                  </span>
                </li>
              </template>
              <template each="{key in Object.keys(state.inputTexts)}">
                <li class="search-conditions_list-item" data-key="{key}">
                  <span
                    class="label label-search-conditions js-label-close"
                    onclick="{e=>delSearchCond(e,key)}"
                  >
                    {state.inputTexts[key].title}:{state.inputTexts[key].value}
                  </span>
                </li>
              </template>
            </ul>
          </div>
          <button
            class="button button-secondary"
            type="button"
            value="検索条件設定"
            data-target=""
            onclick="{e=>goSearch(e)}"
          >
            検索条件設定
          </button>
        </div>
        -->
        <div class="container_sort margin-spacing-2_bottom">
          <div class="box_sort">
            <div class="sort-menu margin-spacing-2_right">
              <select
                name="limit"
                class="sort-list"
                onchange="{(e)=>changeLimit(e)}"
              >
                <option value="10">10件</option>
                <option value="20">20件</option>
                <option value="50">50件</option>
              </select>
            </div>
            <!--/.sort-menu-->
            <div class="sort-menu">
              <select
                name="order"
                class="sort-list"
                onchange="{(e)=>changeOrder(e)}"
              >
                <option value="0">新しい順</option>
                <option value="1">古い順</option>
                <!--
                <option value="0">最新</option>
                <option value="1">報酬料金が高い順</option>
                <option value="2">報酬料金が少ない順</option>
                <option value="3">文字数が多い順</option>
                <option value="4">文字数が少ない順</option>
                -->
              </select>
            </div>
            <!--/.sort-menu-->
          </div>
          <!--/.box_sort-->
          <p class="search_number" if="{ state.pager.total > 0}">
            全{ state.pager.total }件中 { state.limit*(state.pager.page-1) + 1
            }〜{ state.limit*(state.pager.page-1) + state.pager.items.length }件
          </p>
        </div>
        <!--/.container_sort-->
        <template if="{ state.ads.length > 0}">
          <ad-item-tag
            api="{api}"
            ad="{ad}"
            idx="{i}"
            each="{(ad,i) in state.ads}"
            on-interest="{ onInterest }"
          ></ad-item-tag>
          <edilent-pagination-tag
            pager="{state.pager}"
            onpager="{(e,page)=>select(e,page)}"
            if="{state.pager.last > 1}"
          ></edilent-pagination-tag>
        </template>

        <div class="empty margin-spacing-3_top" if="{ state.ads.length === 0}">
          <p class="empty-message">条件にマッチする公募案件がありません。</p>
        </div>
      </div>
      <!--/.tab_contents-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import di from "dependency-injection";
    import adItem from "@tags/pages/ad/ad-item.riot";

    export default {
      di: di,
      components: {
        "ad-item-tag": adItem,
      },
      state: {
        limit: 10,
        order: "price desc",
        ads: [],
        page: 1,
        pager: { page: 1, total: 0, last: 0, prev: 0, next: 0 },
        checkboxes: {},
        inputTexts: {},
      },
      delSearchCond(e, delKey) {
        delete this.state.checkboxes[delKey];
        delete this.state.inputTexts[delKey];
        di.SyncBox.set("ad-search-checkboxes", this.state.checkboxes);
        di.SyncBox.set("ad-search-inputTexts", this.state.inputTexts);
        this.fetchAds();
      },
      goSearch(e) {
        di.router.push("/ad/search");
      },
      select(e, page) {
        e.preventDefault();
        this.state.page = page;
        this.fetchAds();
      },
      changeOrder(e) {
        this.state.order = e.target.value;
        this.state.page = 1;
        this.fetchAds();
      },
      changeLimit(e) {
        this.state.limit = e.target.value;
        this.state.page = 1;
        this.fetchAds();
      },
      onAdsFetched(data) {
        this.update({
          ads: data.items,
          pager: data,
          page: data.page,
        });
      },
      fetchAds() {
        const params = {
          page: this.state.page,
          order: this.state.order,
          limit: this.state.limit,
        };
        Object.keys(this.state.checkboxes).forEach((key) => {
          params[`checkboxes[${key}]`] = true;
        });
        Object.keys(this.state.inputTexts).forEach((key) => {
          params[`inputTexts[${key}]`] = this.state.inputTexts[key].value;
        });
        this.api
          .request("index", "fetch-ads", params)
          .then((data) => this.onAdsFetched(data));
      },
      onBeforeMount(props, state) {
        this.interestApi = di.createApi("interest");
        this.api = di.createApi("ad");
        this.state.checkboxes = di.SyncBox.get("ad-search-checkboxes") || {};
        this.state.inputTexts = di.SyncBox.get("ad-search-inputTexts") || {};
        di.SyncBox.registerHooks(
          "interestedListener",
          "interested:updated",
          (interested) => this.update()
        );
        this.fetchAds();
      },
      onUnmounted(props, state) {
        di.SyncBox.unregisterHooks("interestedListener", "interested:updated");
      },
      async onInterest(e, index) {
        if (this.state.ads[index].in_interest) {
          return;
        }
        try {
          const res = await this.interestApi.request("ad", "register", {
            ad_ids: [this.state.ads[index].ad_id],
          });
          this.state.ads[index].in_interest = true;
          this.update({ ads: this.state.ads });
          di.toast.push(`気になるを登録しました`, "success");
        } catch (e) {
          di.toast.push(e, "negative");
        }
      },
    };
  </script>
</ad-index-tag>
